import { Camera, CameraResultType } from "@src-capacitor/@capacitor/camera"
import { i18n } from "src/boot/i18n"
import { Log } from "src/util/classes/log"
import { showWarningNotification } from "src/util/functions/notifications"

export async function uploadImagesInApp() {
  try {
    const hasPermission = await getCameraPermission()

    if (!hasPermission) {
      const { t } = i18n.global
      const msg = t("notifications.need_camera_permission")
      showWarningNotification(msg)
      return
    }

    const image = await Camera.getPhoto({
      quality: 100,
      allowEditing: false,
      resultType: CameraResultType.Uri,
    })
    const webPath = image.webPath

    if (webPath) {
      //Get the file name
      const imageName = webPath.split("/").pop() || new Date().toJSON() + "." + image.format

      //Get the `File` from the `Photo`
      const urlResponse = await fetch(webPath)
      const blob = await urlResponse.blob()
      const file = new File([blob], imageName, { type: image.format })

      return {
        name: imageName,
        data: file,
        blob: blob,
      }
    }
  } catch (error) {
    Log.error({ message: "Failed to fetch images in android", error })
  }
}

async function getCameraPermission() {
  try {
    let permissions = await Camera.checkPermissions()
    if (permissions.camera !== "granted") {
      permissions = await Camera.requestPermissions()
    }
    return permissions.camera === "granted"
  } catch (error) {
    Log.error({ message: "Failed to get camera permission in android", error })
  }
}
